/** 회원가입 화면 타입 */
export enum JoinViewType {
  /** JOIN_GUIDE */
  JOIN_GUIDE = 'guide',
  /** JOIN_CHECK_USER_INFO */
  JOIN_CHECK_USER_INFO = 'smsGuide',
  /** JOIN_PWD_SETTING */
  JOIN_PWD_SETTING = 'pwdSetting',
  /** JOIN_PIN_SETTING */
  JOIN_PIN_SETTING = 'pinSetting',
}

/** Home Tab Type */
export enum HomeTabType {
  /** 자산 */
  ASSETS = 'assets',
  /** 활동 */
  ACTIVITIES = 'activities',
}

/** 모달 ID */
export enum ModalId {
  ALL_AGREE = 'termsModal-all',
  TERMS_1 = 'termsModal-1',
  TERMS_2 = 'termsModal-2',
  TERMS_3 = 'termsModal-3',
  TERMS_4 = 'termsModal-4',
}

export enum HomeViewType {
  MAIN = 'main',
  SOL = 'sol',
  TOKEN = 'token',
  SEND = 'send',
  SEND_CHECK = 'sendCheck',
  RECEIVE = 'receive',
}

export enum AssetType {
  /** 코인 */
  COIN = 'SOL',
  /** 토큰 */
  TOKEN = 'GDF',
}

export enum SettingViewType {
  /** 메인 */
  MAIN = 'main',
  /** 비밀번호 재설정 */
  PWD_SETTING = 'pwdSetting',
  /** 비밀번호 확인 */
  CHECK_PWD_SETTING = 'checkPwdSetting',
  /** PIN 비밀번호 재설정 */
  PIN_SETTING = 'pinSetting',
  /** 관리지갑 잔액 확인 */
  MANAGE_WALLET_BALANCE = 'manageWalletBalance',
  /** 회원탈퇴 */
  EXIT = 'exit',
}

export enum UserStatus {
  DISABLED,
  ACTIVE,
  PAYMENT,
  ADMIN,
  WITHDRAWN,
}
